import $ from 'jquery';

$(function () {
	const csrf = () => $('meta[name="csrf-token"]').attr('content') || '';

	const $shareModalEl = $('#shareModal');
	const $authModalEl = $('#authRequiredModal');
	const shareModal = $shareModalEl.length ? new window.bootstrap.Modal($shareModalEl[0]) : null;
	const authModal = $authModalEl.length ? new window.bootstrap.Modal($authModalEl[0]) : null;

	let currentShare = { productId: 0, productName: '', productUrl: '' };

	// ---- Wishlist toggle ----
	$(document).on('click', '.js-wishlist-btn', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const productId = parseInt($btn.data('product-id'), 10);
		if (!productId) return;

		$.ajax({
			url: '/wishlist/toggle',
			method: 'POST',
			headers: { 'X-CSRF-TOKEN': csrf(), 'Accept': 'application/json' },
			data: { product_id: productId },
		})
			.done(function (res) {
				if (res && res.status === 'added') {
					$btn.addClass('is-favorite').attr('data-is-favorite', '1');
				} else if (res && res.status === 'removed') {
					$btn.removeClass('is-favorite').attr('data-is-favorite', '0');
				}
				if (res && typeof res.count !== 'undefined') {
					$('.js-wishlist-count[data-product-id="' + productId + '"]').text(res.count);
				}
			})
			.fail(function (xhr) {
				if (xhr.status === 401) {
					if (authModal) authModal.show();
				} else {
					if (window.GlobalSwal) {
						window.GlobalSwal.fire({
							title: window.Lang && window.Lang.error_title_short || 'Error',
							text: window.Lang && window.Lang.wishlist_error || 'Failed to update wishlist.',
							icon: 'error',
						});
					}
				}
			});
	});

	// ---- Share: open modal ----
	$(document).on('click', '.js-share-btn', function (e) {
		e.preventDefault();
		e.stopPropagation();
		if (!shareModal) return;

		currentShare.productId = parseInt($(this).data('product-id'), 10) || 0;
		currentShare.productName = String($(this).data('product-name') || '');
		currentShare.productUrl = String($(this).data('product-url') || '');

		$('#shareModal .js-share-modal-product-name').text(currentShare.productName);
		$('#shareExtraText').val('');
		shareModal.show();
	});

	// ---- Share: pick provider ----
	$(document).on('click', '.js-share-provider', function (e) {
		e.preventDefault();
		const provider = String($(this).data('provider') || '');
		if (!provider || !currentShare.productId) return;

		const extraText = String($('#shareExtraText').val() || '').trim();

		$.ajax({
			url: '/socialshare/store',
			method: 'POST',
			headers: { 'X-CSRF-TOKEN': csrf(), 'Accept': 'application/json' },
			data: {
				product_id: currentShare.productId,
				provider: provider,
				extra_text: extraText,
			},
		})
			.done(function (res) {
				if (!res || res.status !== 'ok') return;

				if (provider === 'copy') {
					const txt = res.share_url && res.share_url.length ? res.share_url : res.url;
					copyToClipboard(res.url);
					if (window.GlobalSwal) {
						window.GlobalSwal.fire({
							title: window.Lang && window.Lang.success_title || 'OK',
							text: window.Lang && window.Lang.share_copied || 'Link copied to clipboard.',
							icon: 'success',
							timer: 1800,
							showConfirmButton: false,
						});
					}
					if (shareModal) shareModal.hide();
					return;
				}

				if (res.share_url) {
					window.open(res.share_url, '_blank', 'noopener,noreferrer,width=640,height=620');
				}
				if (shareModal) shareModal.hide();
			})
			.fail(function () {
				if (window.GlobalSwal) {
					window.GlobalSwal.fire({
						title: window.Lang && window.Lang.error_title_short || 'Error',
						text: window.Lang && window.Lang.share_error || 'Share failed.',
						icon: 'error',
					});
				}
			});
	});

	function copyToClipboard(text) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(text).catch(function () { legacyCopy(text); });
		} else {
			legacyCopy(text);
		}
	}

	function legacyCopy(text) {
		const ta = document.createElement('textarea');
		ta.value = text;
		ta.setAttribute('readonly', '');
		ta.style.position = 'absolute';
		ta.style.left = '-9999px';
		document.body.appendChild(ta);
		ta.select();
		try { document.execCommand('copy'); } catch (err) { /* noop */ }
		document.body.removeChild(ta);
	}
});
